import React, { useEffect, useState } from "react";
import MatchItemDisplay from "../MatchItemDisplay/MatchItemDisplay";

import styles from "./events-panel.module.scss";

const debounce = (func, wait) => {
    let timeout;
    return (...args) => {
      clearTimeout(timeout);
      timeout = setTimeout(() => func(...args), wait);
    };
  };

const EventsPanel = ({eventsToShow, setIsEditModalOpen, setEventDetailsToEdit, setEventsToShow, setIsEditing, setComponentToInsertInModal, matchData, matchId, setMatchData}) => {
    const [height, setHeight] = useState(0);

    const updateHeight = () => {
      const timer = document.getElementById('timer-center');
      if (timer) {
        const timerHeight = parseInt(timer.getBoundingClientRect().height) - 20;
        setHeight(timerHeight);
      }
    };
  
    useEffect(() => {
      updateHeight();
  
      const handleResize = debounce(() => {
        updateHeight();
      }, 100);
      
      window.addEventListener('resize', handleResize);

      return () => {
        window.removeEventListener('resize', handleResize);
      };
    }, []);
  
    return ( 
    <div 
        className={styles['events-panel']}
        style={{
            maxHeight: `calc(100% - ${height}px)`
        }}
    >
        <div className={styles['events-panel__container']}>
        {eventsToShow?.map((evt, i) => {
            return (
            <MatchItemDisplay
                key={i}
                evt={evt}
                setIsEditModalOpen={setIsEditModalOpen}
                setEventDetailsToEdit={setEventDetailsToEdit}
                setEventsToShow={setEventsToShow}
                setIsEditing={setIsEditing}
                setComponentToInsertInModal={setComponentToInsertInModal}
                eventsToShow={eventsToShow}
                matchData={matchData}
                matchId={matchId}
                setMatchData={setMatchData}
                periodAbbr={matchData.formatObject.periodAbbreviation}
            />
            );
        })}
        </div>
    </div>
    )
};

export default EventsPanel;